import { render, staticRenderFns } from "./interFaceStatistics.vue?vue&type=template&id=3faa3226&scoped=true"
import script from "./interFaceStatistics.vue?vue&type=script&lang=js"
export * from "./interFaceStatistics.vue?vue&type=script&lang=js"
import style0 from "./interFaceStatistics.vue?vue&type=style&index=0&id=3faa3226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa3226",
  null
  
)

export default component.exports